import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'cz-ergonomics-evaluation-report-dialog',
  templateUrl: './ergonomics-evaluation-report-dialog.component.html',
  styleUrls: ['./ergonomics-evaluation-report-dialog.component.scss'],
})
export class ErgonomicsEvaluationReportDialogComponent implements OnInit {
  public pdfLink: string;

  constructor(@Inject(MAT_DIALOG_DATA) public data: any, public sanitizer: DomSanitizer) { }

  public ngOnInit(): void {
    let pageParam: string = '';
    if (this.data.pages) {
      const pagesToString: string = this.data.pages && this.data.pages.toString();
      pageParam = pagesToString && `?page=${pagesToString}`;
    }

    this.pdfLink = `./api/pdf/assessment/${this.data.evaluationId}${pageParam}`;
  }

}
